import React, { useState } from 'react';
import {
	Box,
	Grid,
	Autocomplete,
	TextField,
	Button,
	Container,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
	setSelectedArrival,
	setSelectedBusArr,
	setSelectedBusDepart,
	setSelectedDepart,
} from '../../reducers/UiReducer';
import {
	AddSearchFlightDispatch,
	fetchCityDispatch,
} from '../../reducers/HomeReducer';
import { DatePicker, Space } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { Modal } from 'antd';
import moment from 'moment';
import { fetchBusCityDesDispatch } from '../../reducers/BusReducer';
const { RangePicker } = DatePicker;

const ModifyBusSearch = () => {
	const { city } = useSelector((state) => state.home);
	const { depart, arrival } = useSelector((state) => state.ui);
	const { buscity, busDes } = useSelector((state) => state.bus);
	const { busDepart, busArr } = useSelector((state) => state.ui);
	const [filterData, setFilterData] = useState('');
	const [filterData2, setFilterData2] = useState('');
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const [adult, setAdult] = useState(1);
	const [child, setChild] = useState(0);
	const [infant, setInfant] = useState(0);
	const [departDateReturn, setDepartDateReturn] = useState('');
	const [departDate, setDepartDate] = useState('');
	const [loadings, setLoading] = useState(false);
	const [open, setOpen] = useState(false);
	const handleChange = (event) => {
		let results = [];
		console.log('value', event.target.value);
		let value = event.target.value;

		results =
			buscity &&
			buscity?.result &&
			buscity?.result?.cities?.filter((item) => {
				return (
					item.name.toLowerCase().includes(value.toLowerCase()) ||
					item.state.toLowerCase().includes(value.toLowerCase())
				);
			});
		console.log('value', results);
		if (results?.length <= 80) {
			setFilterData(results);
		}
	};
	console.log('first', filterData);
	const handleChange2 = (event) => {
		let value = event.target.value;
		let results = [];
		results =
			busDes &&
			busDes?.result &&
			busDes?.result?.cities?.filter((item) => {
				return (
					item.name.toLowerCase().includes(value.toLowerCase()) ||
					item.state.toLowerCase().includes(value.toLowerCase())
				);
			});
		console.log('searchresult', results);
		if (results?.length < 80) {
			setFilterData2(results);
		}
	};
	const onChange = (date, dateString) => {
		setDepartDate(dateString);
	};
	const onChangeReturn = (date, dateString) => {
		setDepartDateReturn(dateString);
	};
	function disabledDate(current) {
		// Can not select days before today and today
		return current && current < moment().endOf('day');
	}
	const showModal = () => {
		setOpen(true);
	};
	const handleOk = () => {
		setLoading(true);
		setTimeout(() => {
			setLoading(false);
			setOpen(false);
		}, 3000);
	};

	const handleCancel = () => {
		setOpen(false);
	};
	const handleSearch = () => {
		let formData = {
			departure_city: busDepart.name.split(' ')[0],
			arrival_city: busArr.name.split(' ')[0],
			sourceid: busDepart.id,
			destinationid: busArr.id,
			dateofjourney: departDate,
		};
		console.log('formData', formData);
		navigate('/searchresultbus', { state: formData });
	};
	return (
		<div>
			{' '}
			<Box style={{ background: '#721053' }}>
				<Container>
					<Box
						style={{
							// paddingLeft: 100,
							// paddingRight: 100,
							paddingTop: 1,
							paddingBottom: 1,
						}}>
						<Grid container spacing={2} alignItems={'center'}>
							<Grid item xs={12} lg={3}>
								<Autocomplete
									id='country-select-demo'
									sx={{
										width: '100%',
										'& .MuiInputBase-input': {
											color: 'white',
										},
									}}
									options={
										filterData && filterData?.length > 0 ? filterData : []
									}
									autoHighlight
									ListboxProps={{
										className: 'myCustomList',
									}}
									value={busDepart}
									getOptionLabel={(option) =>
										`${option.name}- ${option.state} `
									}
									renderOption={(props, option) => (
										<Box
											component='li'
											sx={{ '& > img': { mr: 2, flexShrink: 0, fontSize: 14 } }}
											{...props}>
											<p style={{ fontSize: 14, marginLeft: 5 }}>
												{option.name} - {option.state}
											</p>
										</Box>
									)}
									onChange={(event, value) => {
										dispatch(setSelectedBusDepart(value));
										let formData = {
											source: value?.id,
										};
										dispatch(fetchBusCityDesDispatch(formData));
									}}
									renderInput={(params) => (
										<TextField
											{...params}
											id='standard-basic'
											variant='standard'
											onChange={handleChange}
											style={{ fontSize: 12, borderBottom: '1px solid white' }}
											inputProps={{
												...params.inputProps,
												autoComplete: 'new-password', // disable autocomplete and autofill
											}}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12} lg={3}>
								<Autocomplete
									id='country-select-demo'
									sx={{
										width: '100%',
										'& .MuiInputBase-input': {
											color: 'white',
										},
									}}
									options={
										filterData2 && filterData2?.length > 0 ? filterData2 : []
									}
									autoHighlight
									ListboxProps={{
										className: 'myCustomList',
									}}
									value={busArr}
									getOptionLabel={(option) =>
										`${option.name}- ${option.state} `
									}
									renderOption={(props, option) => (
										<Box
											component='li'
											sx={{ '& > img': { mr: 2, flexShrink: 0, fontSize: 14 } }}
											{...props}>
											<p style={{ fontSize: 14, marginLeft: 5 }}>
												{option.name} - {option.state}
											</p>
										</Box>
									)}
									onChange={(event, value) => {
										dispatch(setSelectedBusArr(value));
									}}
									renderInput={(params) => (
										<TextField
											{...params}
											id='standard-basic'
											variant='standard'
											onChange={handleChange2}
											style={{ fontSize: 12, borderBottom: '1px solid white' }}
											inputProps={{
												...params.inputProps,
												autoComplete: 'new-password', // disable autocomplete and autofill
											}}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12} lg={3} className='result'>
								<DatePicker
									disabledDate={disabledDate}
									onChange={onChange}
									style={{
										width: '100%',
										padding: 8,
										background: '#721053',
										border: '1px solid #721053',
										color: 'white',
										boxShadow: 'none',
									}}
								/>
							</Grid>{' '}
							<Grid item xs={12} lg={3}>
								<Button
									onClick={handleSearch}
									style={{
										background: '#EC5B24',
										color: 'white',
										width: '100%',
										padding: 6,
										height: 'auto',
									}}>
									Search
								</Button>
							</Grid>
						</Grid>
					</Box>
				</Container>
			</Box>
		</div>
	);
};

export default ModifyBusSearch;
